import React from 'react';
import * as S from '../FiltersBlock/FiltersBlock.styles';
import CustomCheckbox from '../../../../../stories/core-components/Checkbox/Checkbox';
import Icon from '../../../../../stories/core-components/IconsSelector';
import {IFILTER_BLOCK} from './../../../../containers/SRP/validation';
const FiltersBlock = (props: IFILTER_BLOCK) => {
  const {
    boardingPoints,
    droppingPoints,
    operators,
    amenities,
    showAllBoardingPoints,
    showAllDroppingPoints,
    showAllOperators,
    showAllAmenities,
    itemDisplayCount,
    onFiltersReset,
    onFilterSelect,
    onFilterCollapse,
    activeSearchVal,
    onInputFocus,
    activeSearchType,
    onSearchTypeValChange,
    onBlur,
    selectedFilters,
    popularFilters,
    resetActiveSearchVal
  } = props;
  const amenitiesView = getAmenitiesView(
    amenities,
    showAllAmenities,
    itemDisplayCount,
    selectedFilters,
    onFilterSelect,
  );
  const {
    boardingPoint: selectedBoardingPoints,
    droppingPoint: selectedDroppingPoints,
    operator: selectedOperators,
    amenities: selectedAmenities,
    popular,
    busType,
    departureTime,
    arrivalTime,
    single_seat
  } = selectedFilters;
  const isFilters = isFilterEmpty(selectedFilters)
  if (boardingPoints) {
    return (
      <S.FiltersBlockLayoutDiv>
      
        <S.FiltersBlockMainDiv>
          <S.FilterTextSpan>Filters</S.FilterTextSpan>
           <S.ResetElink style={{color:!isFilters ? "" : "#c5c5c5"}} onClick={onFiltersReset} data-val="resetAll">
           Clear All
          </S.ResetElink> 
        </S.FiltersBlockMainDiv>
        <S.FilterWrapperSection>
            {/* new  */}
       {/* { !isFilters && <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>APPLIED FILTERS</S.PopularTextSpan>
          </S.PopularBlockInnerMainDiv>
          <S.NewFiltersMainDiv>
              <S.FiltersAppliedWrapper>
                {
                  Object.keys(selectedFilters).map((key) => {
                    if(key === 'single_seat' && selectedFilters[key] ===true){
                      return (
                        <li>Single Seat <span onClick={() => onFilterSelect(key, !selectedFilters[key])}><img width="12px" height="12px" src="https://gos3.ibcdn.com/crossIcon-1715940297.png" /></span></li>
                      )
                    }
                    else if(selectedFilters[key] && Array.isArray(selectedFilters[key])){
                    return selectedFilters[key]?.map((filter) => {
                      if (['departureTime', 'arrivalTime'].includes(key)) {
                        return (
                          <li>{appliedTimeFilterConfig[filter] || ''}<span onClick={() => onFilterSelect(key, filter)}><img width="12px" height="12px" src="https://gos3.ibcdn.com/crossIcon-1715940297.png" /></span></li>
                        )
                      }
                      else if(key === 'popular'){
                        return(
                          <li>{filter === "CAxSAkAB" ? 'Top Rated' : filter === 'reddeal' ? 'Go Deals' : filter?.toUpperCase()}<span onClick={() => onFilterSelect(key, filter)}><img width="12px" height="12px" src="https://gos3.ibcdn.com/crossIcon-1715940297.png" /></span></li>
                        )
                      }
                      else {
                        return (
                          <li>
                            <span>{key === 'boardingPoint' ? `From: ` : key === 'droppingPoint' ? `To: ` :''}</span>
                            {filter?.toUpperCase() || ''}<span onClick={() => onFilterSelect(key, filter)}><img width="12px" height="12px" src="https://gos3.ibcdn.com/crossIcon-1715940297.png" /></span></li>
                        )
                      }
                    })
                  }
                  else if(key === 'operator'){
                   return Object.keys(selectedFilters[key]).map((filter) => {   
                      return (
                        <li>{selectedFilters[key][filter] || ''}<span onClick={() => onFilterSelect(key, filter)}><img width="12px" height="12px" src="https://gos3.ibcdn.com/crossIcon-1715940297.png" /></span></li>
                      )
                    })
                  }
                 
                  })
                }
              </S.FiltersAppliedWrapper>
          </S.NewFiltersMainDiv>
          
        </S.PopularBlockMainDiv>
      } */}



        {/* Popular Type */}
        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Popular</S.PopularTextSpan>
            {/* <S.ResetElink style={{color:busType.length ? "" : "#c5c5c5"}}  onClick={onFiltersReset} data-val="busType">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>

          <S.BusTypeFiltersWrap>
            {getPopularFilterView(selectedFilters, onFilterSelect, popularFilters)}
          </S.BusTypeFiltersWrap>
        </S.PopularBlockMainDiv>

      

        {/* Bus Type */}
        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Bus Type</S.PopularTextSpan>
            {/* <S.ResetElink style={{color:busType.length ? "" : "#c5c5c5"}}  onClick={onFiltersReset} data-val="busType">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>

          <S.BusTypeFiltersWrap>
            {getBusFilterView(selectedFilters, onFilterSelect)}
          </S.BusTypeFiltersWrap>
        </S.PopularBlockMainDiv>

        {/* Single Seat */}
        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>SINGLE SEATER / SLEEPER</S.PopularTextSpan>
            {/* <S.ResetElink style={{color:busType.length ? "" : "#c5c5c5"}}  onClick={onFiltersReset} data-val="busType">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>

          <S.BusTypeFiltersWrap>
          <S.BusTypeFilterTab
              key={1}
              className={selectedFilters.single_seat  ? 'active' : ''}
              onClick={() => {
                onFilterSelect('single_seat', !selectedFilters.single_seat);
              }}
           >
        <S.TabIconWrap>
        </S.TabIconWrap>
        {'Single Seat'}
      </S.BusTypeFilterTab>,
          </S.BusTypeFiltersWrap>
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Departure Time</S.PopularTextSpan>
            {/* <S.ResetElink  style={{color:departureTime.length ? "" : "#c5c5c5"}}  onClick={onFiltersReset} data-val="departureTime">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>
          <S.BusTypeFiltersWrap>
            {getTimeView(selectedFilters, onFilterSelect, 'departureTime')}
          </S.BusTypeFiltersWrap>
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Arrival Time</S.PopularTextSpan>
            {/* <S.ResetElink  style={{color:arrivalTime.length ? "" : "#c5c5c5"}} onClick={onFiltersReset} data-val="arrivalTime">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>
          <S.BusTypeFiltersWrap>
            {getTimeView(selectedFilters, onFilterSelect, 'arrivalTime')}
          </S.BusTypeFiltersWrap>
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Boarding Point</S.PopularTextSpan>
            <S.ResetElink style={{color:selectedBoardingPoints.length ? "" : "#c5c5c5"}} onClick={onFiltersReset} data-val="boardingPoint">
              Clear All
            </S.ResetElink>
          </S.PopularBlockInnerMainDiv>

          <S.BordingPointOuterWrapperDiv>
            <S.TextBoxContentDiv>
              <S.TextBox
                 name="filterDroppingSearch"
                id="boardingPointFilterSearch"
                placeholder="Enter/Search baording point"
                val={activeSearchType === 'boardingPoint' ? activeSearchVal['boardingPoint'] : ''}
                onFocus={onInputFocus}
                data-val={'boardingPoint'}
                onChange={onSearchTypeValChange}
                onBlur={onBlur}
              ></S.TextBox>
                {activeSearchType === 'boardingPoint' && activeSearchVal['boardingPoint'] ?
                  <S.SearchIconWrap     
                   onClick={()=>{
                    document.getElementById("boardingPointFilterSearch").value=""
                   
                     resetActiveSearchVal('boardingPoint')}}>
            
               <Icon name='CloseIcon'  styleProps={{width: '1.2rem', height: '1.2rem',cursor:"pointer"}} />
               </S.SearchIconWrap>
       
              :
              <S.SearchIconWrap>
                <span><img src="https://gos3.ibcdn.com/SearchIcon-1715942114.png" width="20px" height="20px"/></span>
                {/* <Icon name="SearchIcon" /> */}
                </S.SearchIconWrap>
       
                }
                {/* <Icon name='CloseIcon' styleProps={{width: '1.2rem', height: '1.2rem'}} /> */}
            </S.TextBoxContentDiv>
          </S.BordingPointOuterWrapperDiv>
          {/* <S.SelectedFilterWrap>
            {selectedBoardingPoints.map(function(bpName: string, index) {
              return (
                <S.FilterOuterWrapperDiv key={bpName + index}>
                  <S.CheckButtonWrap>
                    <CustomCheckbox
                      title={bpName}
                      checked={true}
                      onClickCb={() => {
                          

                        onFilterSelect('boardingPoint', bpName);
                      }}
                    />
                  </S.CheckButtonWrap>
                </S.FilterOuterWrapperDiv>
              );
            })}
          </S.SelectedFilterWrap> */}
          <S.DropPointFiltersMainDiv>
            {boardingPoints.map(function(bpName: string, index) {
              if (showAllBoardingPoints || index < itemDisplayCount) {
                return (
                  <S.FilterOuterWrapperDiv key={bpName}>
                    <S.CheckButtonWrap>
                      <CustomCheckbox
                        title={bpName}
                        checked={selectedFilters.boardingPoint.indexOf(bpName) !== -1}
                        onClickCb={() => {
                          onFilterSelect('boardingPoint', bpName);
                        }}
                      />
                    </S.CheckButtonWrap>
                  </S.FilterOuterWrapperDiv>
                );
              }
            })}
          </S.DropPointFiltersMainDiv>

         {boardingPoints.length > itemDisplayCount ? <S.ResetElink onClick={onFilterCollapse} data-val="boardingPoint">
            {`${showAllBoardingPoints ? '-' : '+'} Show ${
              showAllBoardingPoints ? 'less' : 'all'
            } boarding points`}
          </S.ResetElink> :null}
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Dropping Point</S.PopularTextSpan>
            <S.ResetElink  style={{color:selectedDroppingPoints.length ? "" : "#c5c5c5"}} onClick={onFiltersReset} data-val="droppingPoint">
              Clear All
            </S.ResetElink>
          </S.PopularBlockInnerMainDiv>

          <S.BordingPointOuterWrapperDiv>
            <S.TextBoxContentDiv>
              <S.TextBox
              name="filterDroppingSearch"
              id="droppingPointFilterSearch"
                placeholder="Enter/Search dropping point"
                val={activeSearchType === 'droppingPoint' ? activeSearchVal['droppingPoint'] : ''}
                onFocus={onInputFocus}
                data-val={'droppingPoint'}
                onChange={onSearchTypeValChange}
                onBlur={onBlur}
              ></S.TextBox>
              {activeSearchType === 'droppingPoint' && activeSearchVal['droppingPoint'] ?
                <S.SearchIconWrap onClick={()=>{
                  document.getElementById("droppingPointFilterSearch").value=""
                
                  resetActiveSearchVal('droppingPoint')}}   
                >
            
               <Icon name='CloseIcon'  styleProps={{width: '1.2rem', height: '1.2rem',cursor:"pointer"}} />
               </S.SearchIconWrap>
            
              :
              <S.SearchIconWrap>
            
                {/* <Icon name="SearchIcon" /> */}
                <span><img src="https://gos3.ibcdn.com/SearchIcon-1715942114.png" width="20px" height="20px"/></span>
                </S.SearchIconWrap>
                }
            </S.TextBoxContentDiv>
          </S.BordingPointOuterWrapperDiv>
          {/* <S.SelectedFilterWrap>
            {selectedDroppingPoints.map(function(dpName: string, index) {
              return (
                <S.FilterOuterWrapperDiv key={dpName + index}>
                  <S.CheckButtonWrap>
                    <CustomCheckbox
                      title={dpName}
                      checked={true}
                      onClickCb={() => {
                        onFilterSelect('droppingPoint', dpName);
                      }}
                    />
                  </S.CheckButtonWrap>
                </S.FilterOuterWrapperDiv>
              );
            })}
          </S.SelectedFilterWrap> */}

          <S.DropPointFiltersMainDiv>
            {droppingPoints.map(function(dpName: string, index) {
              if (showAllDroppingPoints || index < itemDisplayCount) {
                return (
                  <S.FilterOuterWrapperDiv key={dpName}>
                    <S.CheckButtonWrap>
                      <CustomCheckbox
                        title={dpName}
                        checked={selectedFilters.droppingPoint.indexOf(dpName) !== -1}
                        onClickCb={() => {
                          onFilterSelect('droppingPoint', dpName);
                        }}
                      />
                    </S.CheckButtonWrap>
                  </S.FilterOuterWrapperDiv>
                );
              }
            })}
          </S.DropPointFiltersMainDiv>

         {droppingPoints.length > itemDisplayCount ? <S.ResetElink onClick={onFilterCollapse} data-val="droppingPoint">
            {`${showAllDroppingPoints ? '-' : '+'} Show ${
              showAllDroppingPoints ? 'less' : 'all'
            } dropping points`}
          </S.ResetElink> :null}
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Operator</S.PopularTextSpan>
            <S.ResetElink style={{color:Object.keys(selectedOperators).length ? "" : "#c5c5c5"}}  onClick={onFiltersReset} data-val="operator">
              Clear All
            </S.ResetElink>
          </S.PopularBlockInnerMainDiv>

          <S.BordingPointOuterWrapperDiv>
            <S.TextBoxContentDiv>
              <S.TextBox
                id="operatorFilterSearch"
                name="filteroperatorSearch"
                placeholder="Enter/Search operator"
                val={activeSearchType === 'operator' ? activeSearchVal['operator'] : ''}
                onFocus={onInputFocus}
                data-val={'operator'}
                onChange={onSearchTypeValChange}
                onBlur={onBlur}
              ></S.TextBox>
              {activeSearchType === 'operator' && activeSearchVal['operator'] ?
                    <S.SearchIconWrap onClick={()=>{
                      document.getElementById("operatorFilterSearch").value=""
                      resetActiveSearchVal('operator')}}  
                    >
        
               <Icon name='CloseIcon'   styleProps={{width: '1.2rem', height: '1.2rem',cursor:"pointer"}} />
               </S.SearchIconWrap>
        
              :
              <S.SearchIconWrap>
        
                {/* <Icon name="SearchIcon" /> */}
                <span><img src="https://gos3.ibcdn.com/SearchIcon-1715942114.png" width="20px" height="20px"/></span>
                </S.SearchIconWrap>
        
                }
          
            </S.TextBoxContentDiv>
          </S.BordingPointOuterWrapperDiv>

          {/* <S.SelectedFilterWrap>
            {Object.keys(selectedOperators).map(function(opid: string, index) {
              return (
                <S.FilterOuterWrapperDiv key={opid + index}>
                  <S.CheckButtonWrap>
                    <CustomCheckbox
                      title={selectedOperators[opid]}
                      checked={true}
                      onClickCb={() => {
                        onFilterSelect('operator', opid, selectedOperators[opid]);
                      }}
                    />
                  </S.CheckButtonWrap>
                </S.FilterOuterWrapperDiv>
              );
            })}
          </S.SelectedFilterWrap> */}
          <S.DropPointFiltersMainDiv>
            {operators.map((operator, index) => {
              if (showAllOperators || index < itemDisplayCount) {
                return (
                  <S.FilterOuterWrapperDiv key={operator.name + operator.id}>
                    <S.CheckButtonWrap>
                      <CustomCheckbox
                        title={operator.name}
                        checked={selectedFilters.operator[operator.id] ? true:false }
                        onClickCb={() => {
                          onFilterSelect('operator', operator.id, operator.name);
                        }}
                      />
                    </S.CheckButtonWrap>
                  </S.FilterOuterWrapperDiv>
                );
              }
            })}
          </S.DropPointFiltersMainDiv>
          {operators.length >itemDisplayCount ?
          <S.ResetElink onClick={onFilterCollapse} data-val="operator">
            {`${showAllOperators ? '-' : '+'} Show ${showAllOperators ? 'less' : 'all'} operators`}
          </S.ResetElink> :null}
        </S.PopularBlockMainDiv>

        <S.PopularBlockMainDiv>
          <S.PopularBlockInnerMainDiv>
            <S.PopularTextSpan>Amenities</S.PopularTextSpan>
            {/* <S.ResetElink style={{color:selectedAmenities.length? '':"#c5c5c5"}} onClick={onFiltersReset} data-val="amenities">
              Reset
            </S.ResetElink> */}
          </S.PopularBlockInnerMainDiv>
          {/* <S.SelectedFilterWrap>
            {selectedAmenities.map(function(amenity: string, index) {
              return (
                <S.FilterOuterWrapperDiv key={amenity + index}>
                  <S.CheckButtonWrap>
                    <CustomCheckbox
                      title={amenity}
                      checked={true}
                      onClickCb={() => {
                        onFilterSelect('amenities', amenity);
                      }}
                    />
                  </S.CheckButtonWrap>
                </S.FilterOuterWrapperDiv>
              );
            })}
          </S.SelectedFilterWrap> */}
          <S.NewFiltersMainDiv>{amenitiesView}</S.NewFiltersMainDiv>
      {Object.keys(amenities).length > itemDisplayCount?
          <S.ResetElink onClick={onFilterCollapse} data-val="amenities">
            {`${showAllAmenities ? '-' : '+'} Show ${showAllAmenities ? 'less' : 'all'} Amenities`}
          </S.ResetElink> :null}
        </S.PopularBlockMainDiv>
        </S.FilterWrapperSection>
      </S.FiltersBlockLayoutDiv>
    );
  } else {
    return null;
  }
};
function getAmenitiesView(
  amenities,
  showAllAmenities,
  itemDisplayCount,
  selectedFilters,
  onFilterSelect,
) {
  let amenitiesView = [];
  for (let key in amenities) {
    if (showAllAmenities || amenitiesView.length < itemDisplayCount) {
      amenitiesView.push(
        <S.FilterOuterWrapperDiv key={key+Math.random()}>
          <S.CheckButtonWrap>
            <CustomCheckbox
              title={amenities[key].title}
              name={amenities[key].icon}
              isIcon={true}
              checked={selectedFilters.amenities.indexOf(amenities[key].title) !== -1}
              onClickCb={() => {
                onFilterSelect('amenities', amenities[key].title);
              }}
            />
          </S.CheckButtonWrap>
        </S.FilterOuterWrapperDiv>,
      );
    }
  }
  return amenitiesView;
}

export default FiltersBlock;

const busTypeConfig = [
  {id: 'ac', name: 'AC', icon: 'https://gos3.ibcdn.com/ac-1716464172.png', activeIcon:'https://gos3.ibcdn.com/Path_active-1716463224.png'},
  {id: 'nonac', name: 'Non-AC', icon: 'https://gos3.ibcdn.com/ac-1716464156.png', activeIcon:'https://gos3.ibcdn.com/non_ac_active-1716463371.png'},
  {id: 'seater', name: 'Seater', icon: 'https://gos3.ibcdn.com/seater-1716463687.png', activeIcon:'https://gos3.ibcdn.com/seater_active-1716463355.png'},
  {id: 'sleeper', name: 'Sleeper', icon: 'https://gos3.ibcdn.com/sleeper-1716463700.png', activeIcon:'https://gos3.ibcdn.com/sleeper_active-1716463341.png'},
];
const timeFilterConfig = [
  {id: '00-06', name: '12 midnight - 6 AM', icon: "https://gos3.ibcdn.com/morningIcon-1715940311.png", activeIcon:"https://gos3.ibcdn.com/ic_morning_active-1716463288.png"},
  {id: '06-12', name: '6 AM - 12 noon', icon:"https://gos3.ibcdn.com/ic_noon-1716462792.png", activeIcon:"https://gos3.ibcdn.com/ic_noon_active-1716463272.png"},
  {id: '12-18', name: '12 noon - 6 PM', icon:"https://gos3.ibcdn.com/evening-1716462840.png", activeIcon:"https://gos3.ibcdn.com/Group_active-1716463324.png"},
  {id: '18-24', name: '6 PM - 12 midnight', icon:"https://gos3.ibcdn.com/Group-1716462807.png", activeIcon:"https://gos3.ibcdn.com/Group_active-1716463308.png"},
];

const appliedTimeFilterConfig = 
  { '00-06': '12 midnight - 6 AM',
  '06-12': '6 AM - 12 noon',
   '12-18': '12 noon - 6 PM',
 '18-24': '6 PM - 12 midnight'};
function getBusFilterView(selectedFilters, onFilterSelect) {
  let viewData = [];
  for (let i in busTypeConfig) {
    const isSelected = selectedFilters.busType.indexOf(busTypeConfig[i].id);
    
    viewData.push(
      <S.BusTypeFilterTab
        key={busTypeConfig[i].id}
        className={isSelected !== -1 ? 'active' : ''}
        onClick={() => {
          onFilterSelect('busType', busTypeConfig[i].id);
        }}
      >
        <S.TabIconWrap>
          <img height="14px" src={!isSelected ?busTypeConfig[i].activeIcon : busTypeConfig[i].icon} />
        </S.TabIconWrap>
        {busTypeConfig[i].name}
      </S.BusTypeFilterTab>,
    );
  }
  return viewData;
}
function getPopularFilterView(selectedFilters, onFilterSelect, popularFilters) {
  let viewData = [];
  for (let key of popularFilters) {
    const isSelected =(selectedFilters.popular.includes(key.k) || selectedFilters.busType.includes(key.k) || selectedFilters.departureTime.includes(key.k)) ? true : false;
    if (key?.show) {
      viewData.push(
        <S.BusTypeFilterTab
          key={key.k}
          className={isSelected ? 'active' : ''}
          onClick={() => {
            onFilterSelect(['ac', 'sleeper'].includes(key.k) ? 'busType' : key.k === '18-24' ? 'departureTime' : 'popular', key.k);
          }}
        >
          <S.TabIconWrap>
            <img height="14px" src={isSelected ? key.activeIcon : key.inactiveIcon} />
          </S.TabIconWrap>
          {key.v}
        </S.BusTypeFilterTab>,
      );
    }
  }
  return viewData;
}

function getTimeView(selectedFilters, onFilterSelect, type) {
  let viewData = [];
  for (let i in timeFilterConfig) {
    const isSelected = selectedFilters[type].indexOf(timeFilterConfig[i].id);

    viewData.push(
      <S.BusTypeFilterTab
        key={timeFilterConfig[i].id + type}
        className={isSelected !== -1 ? 'active' : ''}
        onClick={() => {
          onFilterSelect(type, timeFilterConfig[i].id);
        }}
      >
        <p><img width="24px" height="24px" src={!isSelected ?timeFilterConfig[i].activeIcon : timeFilterConfig[i].icon} /></p>
        {timeFilterConfig[i].name}
      </S.BusTypeFilterTab>,
    );
  }

  return viewData;
}
function isFilterEmpty(filters){
let isEmpty = true;
for(let i in filters){
  if(i === 'single_seat' && filters[i] === true){
    isEmpty = false;
  }
 else if(Object.keys(filters[i]) && Object.keys(filters[i]).length){
   isEmpty = false;
 }
}
return isEmpty;
}